import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_3 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

import {computed, ref, watch, onMounted} from "vue";

import BGrid from "./BGrid/BGrid.vue";
import { useDcraStore } from "@/stores/dcraStore";
import { useConfirmDialog } from "@/composable/useConfirmDialog";
import { Death } from "./DcraEditor/schema";
import CreateEditDeath from "./DcraEditor/CreateEditDeath.vue";
import ConfirmModal from "./Misc/ConfirmModal.vue";
import { BTableOptions } from "./BTable/BTable.types";
import AddZeroReport from "./DcraEditor/AddZeroReport.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DcraEditor',
  props: {
    startDate: { default: "1900-01-01" },
    id: { default: '' },
    ori: { default: '' },
    currentState: { default: "" }
  },
  setup(__props: any) {


const {confirm} = useConfirmDialog();
const props = __props;

var selectedDeath = ref({} as number);
var createEditModal = ref(false);
var addZeroReportModal = ref(false);
const createEditDeathRef = ref<{ resetFormState: () => void } | null>(null);

const numberOfReturnedItems = ref(0);
var dcraEditTableOptions = ref({
        totalItemCount: 0,
        itemsPerPage: 25,
        page: 1,
        sortBy: [
            {
                key: "deathDate",
                isDescending: true,
            },
        ],
        pagingMode: "noTotal",
    } as BTableOptions);
    
// Stores
var dcraStore = useDcraStore();

// Computed properties
const dcraData = computed(() => dcraStore.listOfDeaths ?? []);

// Functions
const fetchdata = () => {
    dcraStore.fetchListOfDeaths(dcraEditTableOptions.value).then((returnData)=> {

        if (returnData.status == 200) {
            numberOfReturnedItems.value = returnData?.data?.data?.length ?? 0;
            if (returnData?.data?.data?.length > 0) {
                dcraStore.listOfDeaths = returnData.data.data.slice(0, dcraEditTableOptions.value.itemsPerPage);
            } else {
                dcraStore.listOfDeaths = returnData.data.data;
            }
    
            dcraEditTableOptions.value.totalItemCount = returnData.data.total;
        }
    });
}

const handleNewEntryClick = () => {
    var death = {} as Death;

    createEditDeathRef.value?.resetFormState();
    selectedDeath.value = death.id;
    createEditModal.value = true;
}

const handleNewZeroReportClick = () => {
    addZeroReportModal.value = true;
}

const handleEditEntryClick = (id:number) => {
    createEditDeathRef.value?.resetFormState();
    selectedDeath.value = id;
    createEditModal.value = true;
}

const handleDeleteEntryClick = async (death:Death) => {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        dcraStore.deleteDeath(death.id);
        fetchdata();
    }
}

const handleModalDismiss = () => {
    createEditModal.value = false;
    addZeroReportModal.value = false;
}

//LifeCycle Hooks
onMounted(async ()=> {
    fetchdata();

    if(props.id != '' && props.ori != '') {
        let response = await dcraStore.getDeathIdByIncidentAndOri(props.id, props.ori);
        if (response) {
            handleEditEntryClick(response.data);
        }
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AddZeroReport, {
      modelValue: _unref(addZeroReportModal),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(addZeroReportModal) ? (addZeroReportModal).value = $event : addZeroReportModal = $event)),
      "start-date": props.startDate,
      onDismiss: handleModalDismiss
    }, null, 8, ["modelValue", "start-date"]),
    _createVNode(CreateEditDeath, {
      ref_key: "createEditDeathRef",
      ref: createEditDeathRef,
      modelValue: _unref(createEditModal),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(createEditModal) ? (createEditModal).value = $event : createEditModal = $event)),
      id: _unref(selectedDeath),
      startDate: props.startDate,
      currentState: props.currentState,
      onDismiss: handleModalDismiss
    }, null, 8, ["modelValue", "id", "startDate", "currentState"]),
    _createVNode(BGrid, {
      caption: "List of deaths",
      tableOptions: _unref(dcraEditTableOptions),
      filterableFields: _unref(dcraStore).addEditFilterableFields,
      filterOptions: _unref(dcraStore).addEditFilterOptions,
      onOptionChange: fetchdata,
      items: dcraData.value,
      columns: _unref(dcraStore).AddEditColumns,
      loading: _unref(dcraStore).loading,
      "current-item-count": numberOfReturnedItems.value
    }, {
      pagingStart: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleNewEntryClick()), ["prevent"]))
          }, "Add New Death")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleNewZeroReportClick()), ["prevent"]))
          }, "Add Zero Report")
        ])
      ]),
      "cell.actions": _withCtx(({item}) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _withModifiers(($event: any) => (handleEditEntryClick(item.id)), ["prevent"])
        }, " Edit ", 8, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger ms-2",
          onClick: _withModifiers(($event: any) => (handleDeleteEntryClick(item)), ["prevent"])
        }, " Delete ", 8, _hoisted_5)
      ]),
      _: 1
    }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading", "current-item-count"]),
    _createVNode(ConfirmModal)
  ]))
}
}

})